function scrollTop(){
    const scrollBtn = document.createElement("button");
    scrollBtn.innerHTML = '<svg><use xlink:href="img/sprite.svg#chevron-up"></use></svg>';
    scrollBtn.classList.add("scrollTopBtn");
    scrollBtn.setAttribute("title", "Наверх");
    document.body.appendChild(scrollBtn);
    const scrollBtnDisplay = function () {
        window.scrollY > 0
            ? scrollBtn.classList.add("show")
            : scrollBtn.classList.remove("show");
    };
    window.addEventListener("scroll", scrollBtnDisplay);

    const scrollWindow = function () {
        if (window.scrollY != 0) {
            setTimeout(function () {
                window.scrollTo(0, window.scrollY - 50);
                scrollWindow();
            }, 10);

            // window.scrollTo({top: 0, behavior: 'smooth'}); // chrome bug
        }
    };
    scrollBtn.addEventListener("click", scrollWindow);
}
export default scrollTop